import { css } from "styled-system/css";

export const helpPopupStyles = css({
  position: "absolute",
  bottom: "100%",
  left: "50%",
  transform: "translateX(-50%)",
  marginBottom: "sm",
  zIndex: 100,
  backgroundColor: "bgBase100",
  padding: "md",
  borderRadius: "large",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "bgBase300",
  boxShadow: "lg",
  width: "240px",
  color: "textBase",
  fontSize: "12px",
  fontWeight: "500",
  lineHeight: "1.4",
  opacity: 1,
  pointerEvents: "none",
  textAlign: "left",
});
